export const icon1 = (
    <svg width="1em" height="1em" viewBox="0 0 64 63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M30.125 2.52637C31.2853 1.85649 32.7147 1.85649 33.875 2.52637L56.1553 15.3887C57.3154 16.0586 58.0303 17.297 58.0303 18.6367V44.3633C58.0303 45.703 57.3154 46.9414 56.1553 47.6113L33.875 60.4736C32.7873 61.1016 31.463 61.1413 30.3457 60.5918L30.125 60.4736L7.84473 47.6113C6.68457 46.9414 5.96974 45.703 5.96973 44.3633V18.6367C5.96974 17.297 6.68457 16.0586 7.84473 15.3887L30.125 2.52637Z"
            stroke="currentColor"
            strokeWidth="2.5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 22.4997C17 21.5792 17.7462 20.833 18.6667 20.833H45.3333C46.2538 20.833 47 21.5792 47 22.4997V42.4997C47 43.4201 46.2538 44.1663 45.3333 44.1663H18.6667C17.7462 44.1663 17 43.4201 17 42.4997L17 22.4997Z"
            stroke="currentColor"
            strokeWidth="2.5"
        />
        <path
            d="M21.6971 26.648H30.9491V28.592H23.9471V31.958H30.4271V33.794H23.9471V37.556H31.0751V39.5H21.6971V26.648ZM31.577 26.648H33.917L37.139 36.818H37.175L40.469 26.648H42.755L38.363 39.5H35.861L31.577 26.648Z"
            fill="currentColor"
        />
        <path d="M22 18.373C22 17.8909 22.3909 17.5 22.873 17.5H24.4603C24.9425 17.5 25.3333 17.8909 25.3333 18.373V20.8333H22V18.373Z" fill="currentColor" />
        <path
            d="M38.667 18.373C38.667 17.8909 39.0579 17.5 39.54 17.5H41.1273C41.6095 17.5 42.0003 17.8909 42.0003 18.373V20.8333H38.667V18.373Z"
            fill="currentColor"
        />
    </svg>
);

export const icon2 = (
    <svg width="1em" height="1em" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M30.125 3.52637C31.2853 2.85649 32.7147 2.85649 33.875 3.52637L56.1553 16.3887C57.3154 17.0586 58.0303 18.297 58.0303 19.6367V45.3633C58.0303 46.703 57.3154 47.9414 56.1553 48.6113L33.875 61.4736C32.7873 62.1016 31.463 62.1413 30.3457 61.5918L30.125 61.4736L7.84473 48.6113C6.68457 47.9414 5.96974 46.703 5.96973 45.3633V19.6367C5.96974 18.297 6.68457 17.0586 7.84473 16.3887L30.125 3.52637Z"
            stroke="currentColor"
            strokeWidth="2.5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 20.6667C13 19.7462 13.7462 19 14.6667 19H41.3333C42.2538 19 43 19.7462 43 20.6667V38.3333C43 39.2538 42.2538 40 41.3333 40H14.6667C13.7462 40 13 39.2538 13 38.3333L13 20.6667Z"
            stroke="currentColor"
            strokeWidth="2.5"
        />
        <path
            d="M15.9647 25.932H20.1767C21.6527 25.932 22.6727 26.652 22.6727 28.056C22.6727 28.92 22.2527 29.508 21.4487 29.88V29.904C22.4807 30.132 23.0567 30.948 23.0567 32.112C23.0567 33.648 21.8567 34.5 19.9607 34.5H15.9647V25.932ZM17.4647 29.52H19.9367C20.6207 29.52 21.1727 29.1 21.1727 28.32C21.1727 27.528 20.7767 27.156 19.9607 27.156H17.4647V29.52ZM17.4647 33.276H20.1527C21.0047 33.276 21.5567 32.784 21.5567 31.92C21.5567 31.044 20.9807 30.6 20.1527 30.6H17.4647V33.276ZM24.39 25.932H26.502L28.866 32.64H28.89L31.194 25.932H33.282V34.5H31.854V27.888H31.83L29.454 34.5H28.218L25.842 27.888H25.818V34.5H24.39V25.932ZM38.018 25.728C39.878 25.728 41.294 26.736 41.306 28.464H39.806V28.452C39.71 27.444 39.11 26.952 37.958 26.952C37.058 26.952 36.386 27.348 36.386 28.068C36.386 28.632 36.746 29.004 37.478 29.196L39.77 29.796C40.502 29.988 41.546 30.684 41.546 32.016C41.546 33.708 40.154 34.704 38.138 34.704C35.99 34.704 34.598 33.612 34.562 31.644H36.062C36.074 32.868 36.926 33.48 38.234 33.48C39.386 33.48 40.046 32.94 40.046 32.184C40.046 31.644 39.782 31.272 39.338 31.128C38.858 30.972 38.486 30.864 36.89 30.456C35.534 30.12 34.886 29.364 34.886 28.248C34.886 26.508 36.458 25.728 38.018 25.728Z"
            fill="currentColor"
        />
        <path
            d="M45 27H49.3333C50.2538 27 51 27.7462 51 28.6667V45.3333C51 46.2538 50.2538 47 49.3333 47H20.6667C19.7462 47 19 46.2538 19 45.3333V42.7895"
            stroke="currentColor"
            strokeWidth="2.5"
        />
    </svg>
);

export const icon3 = (
    <svg width="1em" height="1em" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M29.625 2.52637C30.7853 1.85649 32.2147 1.85649 33.375 2.52637L55.6553 15.3887C56.8154 16.0586 57.5303 17.297 57.5303 18.6367V44.3633C57.5303 45.703 56.8154 46.9414 55.6553 47.6113L33.375 60.4736C32.2873 61.1016 30.963 61.1413 29.8457 60.5918L29.625 60.4736L7.34473 47.6113C6.18457 46.9414 5.46974 45.703 5.46973 44.3633V18.6367C5.46974 17.297 6.18457 16.0586 7.34473 15.3887L29.625 2.52637Z"
            stroke="white"
            strokeWidth="2.5"
        />
        <path
            d="M17 19.7132L32.0072 15.3335L47 19.7132V28.6949C47 38.1353 40.9585 46.5163 32.0022 49.5006C23.0434 46.5164 17 38.1335 17 28.6907V19.7132Z"
            stroke="white"
            strokeWidth="2.5"
            strokeLinejoin="round"
        />
        <path d="M24.5 31.1667L30.3333 37L40.3333 27" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const icon4 = (
    <svg width="1em" height="1em" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M30.125 3.52637C31.2853 2.85649 32.7147 2.85649 33.875 3.52637L56.1553 16.3887C57.3154 17.0586 58.0303 18.297 58.0303 19.6367V45.3633C58.0303 46.703 57.3154 47.9414 56.1553 48.6113L33.875 61.4736C32.7873 62.1016 31.463 62.1413 30.3457 61.5918L30.125 61.4736L7.84473 48.6113C6.68457 47.9414 5.96974 46.703 5.96973 45.3633V19.6367C5.96974 18.297 6.68457 17.0586 7.84473 16.3887L30.125 3.52637Z"
            stroke="currentColor"
            strokeWidth="2.5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.625 47.125C36.2149 47.125 39.125 44.1239 39.125 40.4219C39.125 34.1656 32.625 29.25 32.625 29.25C32.625 29.25 26.125 34.1656 26.125 40.4219C26.125 44.1239 29.0351 47.125 32.625 47.125Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0625 30.875C24.3062 30.875 26.125 28.9652 26.125 26.6094C26.125 22.6281 22.0625 19.5 22.0625 19.5C22.0625 19.5 18 22.6281 18 26.6094C18 28.9652 19.8188 30.875 22.0625 30.875Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.125 27.625C40.9199 27.625 42.375 25.988 42.375 23.9688C42.375 20.5563 39.125 17.875 39.125 17.875C39.125 17.875 35.875 20.5563 35.875 23.9688C35.875 25.988 37.3301 27.625 39.125 27.625Z"
            fill="currentColor"
        />
    </svg>
);

export const linkBtn = (idx: number) => (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <foreignObject x="-3.66667" y="-3.66667" width="39.3333" height="39.3333">
            <div
                xmlns="http://www.w3.org/1999/xhtml"
                style={{ backdropFilter: 'blur(1.83px)', clipPath: `url(#bgblur_0_2797_62932_clip_path_${idx})`, height: '100%', width: '100%' }}
            ></div>
        </foreignObject>
        <g data-figma-bg-blur-radius="3.66667">
            <rect x="32" width="32" height="32" rx="16" transform="rotate(90 32 0)" fill={`url(#paint0_linear_2797_62932_${idx})`} fillOpacity="0.62" />
            <rect
                x="31.8333"
                y="0.166667"
                width="31.6667"
                height="31.6667"
                rx="15.8333"
                transform="rotate(90 31.8333 0.166667)"
                stroke={`url(#paint1_linear_2797_62932_${idx})`}
                strokeOpacity="0.6"
                strokeWidth="0.333333"
            />
            <path
                d="M12.4936 13.8235C12.1976 13.5253 11.7178 13.5253 11.4218 13.8235C11.1258 14.1217 11.1258 14.6052 11.4218 14.9035L15.4639 18.9761C15.7573 19.2718 16.2321 19.2748 16.5291 18.9828L20.5712 15.0092C20.8708 14.7147 20.8767 14.2312 20.5844 13.9293C20.2921 13.6275 19.8122 13.6215 19.5126 13.916L16.0063 17.3629L12.4936 13.8235Z"
                fill="white"
                fillOpacity="0.8"
            />
        </g>
        <defs>
            <clipPath id={`bgblur_0_2797_62932_clip_path_${idx}`} transform="translate(3.66667 3.66667)">
                <rect x="32" width="32" height="32" rx="16" transform="rotate(90 32 0)" />
            </clipPath>
            <linearGradient id={`paint0_linear_2797_62932_${idx}`} x1="32" y1="16" x2="61" y2="5.33333" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" stopOpacity="0.39" />
                <stop offset="1" stopColor="#2D2E36" stopOpacity="0.46" />
            </linearGradient>
            <linearGradient id={`paint1_linear_2797_62932_${idx}`} x1="30.3333" y1="29" x2="64" y2="16" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#54577E" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>
);
